import ReactGA from 'react-ga';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const initializeReactGA = () => {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
};

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    initializeReactGA();
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);
};

export const sendAnalyticsPath = (path) => {
  initializeReactGA();

  ReactGA.pageview(path);
};

export const sendAnalyticsEvent = (category, action) => {
  initializeReactGA();

  ReactGA.event({ category, action });
};
